"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "INPUT", {
  enumerable: !0,
  get: function get() {
    return _input.INPUT;
  }
}), Object.defineProperty(exports, "INPUT_STYLE_OBJECT", {
  enumerable: !0,
  get: function get() {
    return _input.INPUT_STYLE_OBJECT;
  }
}), Object.defineProperty(exports, "AUTO_COMPLETE", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.AUTO_COMPLETE;
  }
}), Object.defineProperty(exports, "AUTO_COMPLETE_OPTION", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.AUTO_COMPLETE_OPTION;
  }
}), Object.defineProperty(exports, "AUTO_COMPLETE_PREFIX", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.AUTO_COMPLETE_PREFIX;
  }
}), Object.defineProperty(exports, "AUTO_COMPLETE_SUFFIX", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.AUTO_COMPLETE_SUFFIX;
  }
}), Object.defineProperty(exports, "AUTO_COMPLETE_VALUE", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.AUTO_COMPLETE_VALUE;
  }
}), Object.defineProperty(exports, "LIST_OPTION", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.LIST_OPTION;
  }
}), Object.defineProperty(exports, "LIST_CONTAINER", {
  enumerable: !0,
  get: function get() {
    return _autoComplete.LIST_CONTAINER;
  }
});

var _input = require("./input"),
    _autoComplete = require("./autoComplete");